(() => {
  'use strict';

  const KEY   = 'dinHideKlaviyoPopup';
  const PARAM = 'din_custom_discount';
  const ATTR  = 'data-din-hide-klaviyo';

  const params   = new URLSearchParams(location.search);
  const hasQuery = params.has(PARAM);

  // Persist for this tab if the param is present
  if (hasQuery) {
    try { sessionStorage.setItem(KEY, '1'); } catch (_) {}
  }

  // Decide whether to hide
  let shouldHide = hasQuery;
  try { shouldHide = shouldHide || sessionStorage.getItem(KEY) === '1'; } catch (_) {}

  if (!shouldHide) return;

  // Toggle the attribute -> CSS takes care of the rest
  document.documentElement.setAttribute(ATTR, '1');
})();
